import { apiInfo, fetchRequest, HTTPMethod, Resource } from './api';

export const getPhotogramsById = (movieId) => {
    return fetchRequest(HTTPMethod.GET, `${apiInfo.base}/${Resource.PHOTOGRAMS}?movie=${movieId}`);
};
